(ns common.holding-exit-status
  (:require
   [common.util :as cu]))

(defonce exit-statuses
         {:holding.exit-status/not-exited {:translations {:en "Not exited"}}
          :holding.exit-status/exited     {:translations {:en "Exited"}}})

(def options
  (->> exit-statuses
       (map (fn [[k e-m]]
              {:key   k
               :label (->> e-m
                           :translations
                           :en)}))))

(defn get-label
  [k]
  (->> options
       (cu/filter-by :key k)
       (first)
       :label))
